export default "__VITE_ASSET__55e80291__"